import { render, staticRenderFns } from "./Profile.html?vue&type=template&id=5c3346de&scoped=true&"
import script from "./Profile.js?vue&type=script&lang=js&"
export * from "./Profile.js?vue&type=script&lang=js&"
import style0 from "./Profile.scss?vue&type=style&index=0&id=5c3346de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3346de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
